import { IS_BROWSER } from '@constants/globals'

const sendExtensionEvent = (msg: string, data?: {}) =>
  IS_BROWSER && window.GR_EXTENSION_SEND?.(msg, data)

export const enableGoExtension = () => sendExtensionEvent('enable-superhuman-go')
export const extensionNotifyUserSessionChange = () => sendExtensionEvent('changed-user')
